import { render } from "./SpendingCategoryPanels.vue?vue&type=template&id=8f7b14fc&scoped=true"
import script from "./SpendingCategoryPanels.vue?vue&type=script&lang=js"
export * from "./SpendingCategoryPanels.vue?vue&type=script&lang=js"

import "./SpendingCategoryPanels.vue?vue&type=style&index=0&id=8f7b14fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7b14fc"]])

export default __exports__